module.exports = __webpack_public_path__ + "img/01.bc03255a.jpg";